export default __webpack_public_path__ + "static/media/login_bg_900.a99fec77.png";